import { useEffect, useState } from "react";

import { adminApi, type BackupRecoveryResponse } from "../api";
import { StatusTile } from "../components/StatusTile";

export function BackupRecovery(): JSX.Element {
  const [data, setData] = useState<BackupRecoveryResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .get<BackupRecoveryResponse>("/api/v1/admin/backup-recovery")
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div>
      <h2 className="page-title">💾 Backup & Recovery</h2>
      <p className="page-subtitle">
        Provider map + recent restore-drill results. Emergency, project-wide restore lives under
        🆘 Break Glass.
      </p>
      {error && <div className="error-banner">{error}</div>}
      {data && (
        <>
          <div className="status-grid">
            <StatusTile status={data.status} />
          </div>
          <div className="panel">
            <h3>Provider map</h3>
            <p className="page-subtitle">
              “Immutable” is about the provider, not the copy’s state. Cloudflare R2 implements no
              part of S3 Object Lock, so a backup copy there is a second, cross-cloud copy that
              nothing in this system can delete — but it is not protected against someone holding
              the recovery credentials. Only Backblaze B2 can enforce that.
            </p>
            <table>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Backup?</th>
                  <th>State</th>
                  <th>Count</th>
                  <th>Immutable?</th>
                </tr>
              </thead>
              <tbody>
                {data.provider_map.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.provider}</td>
                    <td>{row.is_backup ? "yes" : "no"}</td>
                    <td>{row.state}</td>
                    <td>{row.count}</td>
                    <td>
                      {!row.is_backup
                        ? "—"
                        : !row.provider_enforces_object_lock
                          ? "no — provider has no Object Lock"
                          : row.with_worm_until === row.count
                            ? `yes (${row.with_worm_until}/${row.count})`
                            : `partial (${row.with_worm_until}/${row.count})`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="panel">
            <h3>Recent restore drills</h3>
            <table>
              <thead>
                <tr>
                  <th>Outcome</th>
                  <th>Source</th>
                  <th>Detail</th>
                </tr>
              </thead>
              <tbody>
                {data.recent_drills.map((d) => (
                  <tr key={d.id}>
                    <td>{d.outcome}</td>
                    <td>{d.source}</td>
                    <td>{d.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
